export const PRODUCTS = 'Product';
export const VOLUME = 'Volume';
export const REVENUE = 'Revenue';
export const NETBACK = 'Netback';
export const MARGIN = 'Margin';
export const CREDIT = 'Credit';
export const OPTIONS_VALUE = 'TOTAL OPTIONS VALUE';
export const CAP = 'Cap';
export const FLOOR = 'Floor';
export const PUSH = 'Push';
export const PULL = 'Pull';
export const EARLY_TERMINATION = 'Early Termination';
export const EXTENSION = 'Extension';
export const OFFER_TYPE = 'Offer Type';
export const PRICING_FORMULA = 'Pricing Formula';
export const HEADLINE_SIZE = 'Headline Size';
export const COST_TO_SERVE_YIELD = 'Cost-to-serve yield';
export const COST_OF_SUPPLY = 'COST OF SUPPLY';
export const LOGISTIC_FIXED_COST = 'LOGISTIC FIXED COST';
export const INCREMENTAL_INVENTORY_REQUIRED = 'ADDITIONAL INVENTORY';
export const MODE_OF_TRANSPORT = 'Mode of Transport';
export const INCOTERM = 'Incoterm';
export const OTHER_SUPPLY_ITEMS = 'Other Supply Items';
export const CREDIT_DETAILS = 'CREDIT DETAILS';
export const PROBABILITY_OF_DEFAULT = 'Probability of Default';
export const EXPOSURE = 'Exposure';
export const OTHER_CREDIT_ITEMS = 'Other Credit Items';
export const VOLUME_DETAILS = 'VOLUME DETAILS';
export const PUSH_OPTION = 'PUSH OPTION';
export const PULL_OPTION = 'PULL OPTION';
export const SWITCH_PRICE = 'Price-switch';
export const NON_STANDARD_RISKS = 'Non-standard Risk';
export const TOTAL_SUPPLY_COST = 'Total supply cost';
export const REIMBURSED_SUPPLY_COST = 'Reimbursed supply cost';
export const VARIABLE_SUPPLY_COST = 'Variable supply cost';
export const FIXED_ANNUAL_SUPPLY_COST = 'Fixed Annual Supply Cost';
export const ADDITIONAL_INVENTORY = 'Additional Inventory';
export const ADDITIONAL_TRANSIT_DAY = 'Additional transit Day';
export const CREDIT_TERM = 'Credit Term';
export const OPTIONS = 'Options';
export const DESCRIPTION = 'Description';
export const CUSTOMER_FLEX = 'Customer Flex';
export const CONTRACT_BATNA1 = 'Margin, Contract - BATNA1';
export const MARGINATRISK = 'Margin at Risk';
export const SHARPERATIO = 'Sharpe Ratio';
export const OPTIONVALUE = 'Margin, Contract – Contract w/o Options';
export const ALL_PRODUCTS = 'All Products';

export const headersData = [
  {
    header: PRODUCTS,
    subHeader: [],
  },
  {
    header: OFFER_TYPE,
    subHeader: [],
  },
  {
    header: PRICING_FORMULA,
    subHeader: [],
  },
  {
    header: VOLUME,
    subHeader: [],
  },
  {
    header: HEADLINE_SIZE,
    subHeader: [],
  },
  {
    header: REVENUE,
    subHeader: [],
  },
  {
    header: NETBACK,
    subHeader: [],
  },
  {
    header: MARGIN,
    subHeader: [],
  },

  {
    header: COST_TO_SERVE_YIELD,
    subHeader: [
      TOTAL_SUPPLY_COST,
      REIMBURSED_SUPPLY_COST,
      VARIABLE_SUPPLY_COST,
      FIXED_ANNUAL_SUPPLY_COST,
      ADDITIONAL_INVENTORY,
      ADDITIONAL_TRANSIT_DAY,
      MODE_OF_TRANSPORT,
      INCOTERM,
      OTHER_SUPPLY_ITEMS,
    ],
  },
  {
    header: CREDIT_TERM,
    subHeader: [CREDIT, PROBABILITY_OF_DEFAULT, EXPOSURE, OTHER_CREDIT_ITEMS],
  },
  {
    header: OPTIONS,
    subHeader: [CAP, FLOOR, CUSTOMER_FLEX, PUSH, PULL, EXTENSION, EARLY_TERMINATION, SWITCH_PRICE],
  },
  {
    header: NON_STANDARD_RISKS,
    subHeader: [],
  },
  {
    header: CONTRACT_BATNA1,
    subHeader: [],
  },
  {
    header: MARGINATRISK,
    subHeader: [],
  },
  {
    header: SHARPERATIO,
    subHeader: [],
  },
  {
    header: OPTIONVALUE,
    subHeader: [],
  },
];

export interface IShowOptions {
  cap: boolean;
  customerFlex: boolean;
  earlyTermination: boolean;
  extensions: boolean;
  priceSwitch: boolean;
  pushVal: boolean;
  pullVal: boolean;
  floor: boolean;
}
